import { render, staticRenderFns } from "./SchedulingBasis.vue?vue&type=template&id=450acb74"
import script from "./SchedulingBasis.vue?vue&type=script&lang=js"
export * from "./SchedulingBasis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports